import React from 'react';

const CartRecommendationsSkeleton: React.FC<{isCartPage: boolean}> = ({isCartPage}) => (
  <div className={`animate-pulse ${isCartPage ? 'px-2.5 mt-8 md:px-1' : 'px-2.5 mt-8'}`}>
    <div className="h-6 w-60 bg-gray-300 rounded mb-4"></div>
    <div className={`grid grid-cols-1 gap-4 ${isCartPage ? 'md:grid-cols-3 md:gap-8' : ''}`}>
      {[...Array(3)].map((_, index) => (
        <div key={index} className={`w-full flex items-center gap-4 ${isCartPage ? 'md:items-start md:flex-col' : ''}`}>
          <div className={`aspect-square w-15 h-15 flex justify-center items-center bg-gray-300 rounded shadow-md ${isCartPage ? 'md:w-full md:h-full' : ''}`}></div>
          <div
            className={`w-full flex-1 flex gap-2 justify-between items-center ${
              isCartPage ? 'md:flex-col md:items-start' : ''
            }`}
          >
            <div className="w-full flex flex-col">
              <div className="w-7/12 h-4 bg-gray-300 rounded mb-2"></div>
              <div className="w-2/12 h-4 bg-gray-300 rounded"></div>
            </div>
            <div className="w-3/12 h-7.5 bg-gray-300 rounded-full"></div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default CartRecommendationsSkeleton;